import keyMirror from 'key-mirror'

export default keyMirror({
  
  /** Global actions */
  UPDATE_MEDIA: null,

  /** Compositor */
  ON_CELL_MOUSEOVER: null,

  ON_CELL_MOUSEUP: null,

  ON_GRID_MOUSEDOWN: null,

  ON_GRID_TOUCHSTART: null,

  ON_CELL_TOUCHMOVE: null,

  ON_CELL_TOUCHEND: null,

  SHOW_COMPOSER_DIALOG: null,

  HIDE_COMPOSER_DIALOG: null,

  ON_COMPOSER_LOAD: null,

  ON_CHANGE_BPM_SLIDER: null,

  ON_CHANGE_SECTION_SLIDER: null,

  ON_AUDIO_SELECT_CLICK: null,

  ON_COMPOSER_PLAY_CLICK: null,
  
  ON_COMPOSER_PAUSE_CLICK: null,

  SEND_COMPOSER_REQUEST: null,

  SEND_COMPOSER_SUCCESS: null,

  SEND_COMPOSER_FAILURE: null,

  GET_COMPOSITIONS_REQUEST: null,

  GET_COMPOSITIONS_SUCCESS: null,

  GET_COMPOSITIONS_FAILURE: null,

  GET_COMPOSITION_DETAIL_REQUEST: null,

  GET_COMPOSITION_DETAIL_SUCCESS: null,

  GET_COMPOSITION_DETAIL_FAILURE: null,

  SHOW_SEND_COMPOSER_DIALOG: null,

  HIDE_SEND_COMPOSER_DIALOG: null,

  SHOW_COMPOSITION_DETAIL: null,

  SHOW_FORCE_SHARE_COMPOSITION: null,

  HIDE_FORCE_SHARE_COMPOSITION: null,

})


// WEBPACK FOOTER //
// ./src/lib/constants.js